module.exports = __webpack_public_path__ + "media/images/vp/bg.heart.blue-4cc8cd2a51f998802999fbb7178a03ee.png";